import React, { useState } from 'react'
import { isMobile } from '../../../../services/breakpoints.service'
import {
	SectionContainer,
	SectionTitle,
	TabsContainer,
	TabButton,
	ImageContainer,
	ModalityImage
} from './seat-modalities-section.styles'

const modalities = [
	{
		label: 'Convencional',
		desktopImage:
			'https://institucional.planalto.com.br/wp-content/uploads/sites/3/2024/01/Servico_Site_Planalto_2023_Convencional.png',
		mobileImage:
			'https://institucional.planalto.com.br/wp-content/uploads/sites/3/2024/01/servico_site_planalto_mobile_02.png'
	},
	{
		label: 'Executivo | Semi-Leito',
		desktopImage:
			'https://institucional.planalto.com.br/wp-content/uploads/sites/3/2024/01/Servico_Site_Planalto_2023_Executivo.png',
		mobileImage:
			'https://institucional.planalto.com.br/wp-content/uploads/sites/3/2024/01/servico_site_planalto_mobile_03.png'
	},
	{
		label: 'Leito',
		desktopImage:
			'https://institucional.planalto.com.br/wp-content/uploads/sites/3/2024/01/Servico_Site_Planalto_2023_Leito.png',
		mobileImage:
			'https://institucional.planalto.com.br/wp-content/uploads/sites/3/2024/01/servico_site_planalto_mobile_01.png'
	},
	{
		label: 'Leito-Cama',
		desktopImage:
			'https://institucional.planalto.com.br/wp-content/uploads/sites/3/2024/01/Servico_Site_Planalto_2023_Leito_Cama.png',
		mobileImage:
			'https://institucional.planalto.com.br/wp-content/uploads/sites/3/2024/01/servico_site_planalto_mobile_04.png'
	}
]

const SeatModalitiesSection = () => {
	const [activeTab, setActiveTab] = useState(0)
	const mobile = isMobile()
	const activeModality = modalities[activeTab]
	const imageSrc = mobile
		? activeModality.mobileImage
		: activeModality.desktopImage

	return (
		<SectionContainer>
			<SectionTitle>Conheça nossos Serviços</SectionTitle>
			<TabsContainer>
				{modalities.map((modality, index) => (
					<TabButton
						key={index}
						active={activeTab === index}
						onClick={() => setActiveTab(index)}>
						{modality.label}
					</TabButton>
				))}
			</TabsContainer>
			<ImageContainer>
				<ModalityImage
					key={activeTab}
					src={imageSrc}
					alt={`Poltrona ${activeModality.label}`}
				/>
			</ImageContainer>
		</SectionContainer>
	)
}

export default SeatModalitiesSection
